import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class IssueService {
  uri = 'https://www.websoullabs.com';
  constructor(private http: HttpClient) {}

  addContactus(name, email, phone, subject, message) {
    const contact = {
      name: name,
      email: email,
      phone: phone,
      subject: subject,
      message: message,
    };
    return this.http.post(`${this.uri}/contactus`, contact, {
      responseType: 'text',
    });
  }

  addCareerdb(formData) {
    return this.http
      .post(`${this.uri}/career`, formData)
      .subscribe((data) => console.log(data));
  }
}
